import DashboardRateCardList, { DashboardRateCardListProps } from './DashboardRateCardList';

export type { DashboardRateCardListProps };
export default DashboardRateCardList;
